export default ({ id, _set }) => ({
  id,
  _set
})
